import React, { PropsWithChildren } from 'react';
import type {
  IDataContext,
  IDataProviderProps,
  DataProvider,
  DataProviders
} from './types';

export const defaultDataProvider: DataProviders = {
  default: {} as DataProvider
};

export const DataContext = React.createContext<IDataContext>({
  default: {} as DataProvider
});
export const DataContextProvider: React.FC<
  PropsWithChildren<IDataProviderProps>
> = ({ children, dataProvider }) => {
  let providerValue = defaultDataProvider;

  if (dataProvider) {
    providerValue = dataProvider as DataProviders;
  }

  return (
    <DataContext.Provider value={providerValue}>
      {children}
    </DataContext.Provider>
  );
};
